import type { Control } from 'react-hook-form';
import { Button } from '../../ui/button';
import { FormRenderer } from '../renderers/form-renderer';
import type { FormFieldSchema } from '../types';

interface PreviewInputPanelProps {
  fields: FormFieldSchema[];
  control: Control<Record<string, unknown>>;
  isValid: boolean;
  formValues: Record<string, unknown>;
  onUploadFile?: (file: File, category?: string) => Promise<number>;
  onGetFile?: (fileId: number) => Promise<{ fileName: string; fileType: string; viewUrl?: string }>;
}

export function PreviewInputPanel({
  fields,
  control,
  isValid,
  formValues,
  onUploadFile,
  onGetFile,
}: PreviewInputPanelProps) {
  return (
    <div className="flex flex-col min-h-0 bg-card">
      <div className="p-3 bg-muted/30 border-b text-[10px] font-bold uppercase tracking-widest text-muted-foreground flex justify-between items-center">
        <span>Input Mode</span>
        <span className="h-1.5 w-1.5 rounded-full bg-blue-500 animate-pulse" />
      </div>
      <div className="flex-1 overflow-y-auto p-8 custom-scrollbar">
        <div className="max-w-md mx-auto">
          <FormRenderer
            fields={fields}
            mode="edit"
            control={control}
            onUploadFile={onUploadFile}
            onGetFile={onGetFile}
          />
          <Button
            className="w-full mt-10 shadow-lg shadow-primary/20 transition-all active:scale-[0.98]"
            onClick={() => console.log('Submit', formValues)}
            disabled={!isValid}
          >
            Test Submit
          </Button>
          {!isValid && (
            <p className="text-[10px] text-center text-amber-600 mt-3 font-medium animate-in fade-in slide-in-from-top-1">
              Fill all required fields to enable submit
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
